var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"our-text-field",class:_vm.fieldClasses,attrs:{"data-cy":_vm.dataCy}},[_c('div',{staticClass:"our-text-field-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default",function(){return [_c('div',{staticClass:"our-text-field-value"},[_vm._v(" "+_vm._s(_vm.value)+" ")])]},{"value":_vm.value})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }